import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { CloseGrievanceDialogComponent } from 'src/app/grievance/close-grievance-dialog/close-grievance-dialog.component';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { ProjectConstants } from 'src/app/grievance/project-constants';
import { GrievanceTypeService } from '../grievance-type.service';
import { CommonFunction } from 'src/app/grievance/common-function';
import { FormControl, FormGroup, Validators } from '@angular/forms';
const COLS = [
  { value: "GRIEVANCE TYPE ID", lowercaseValue: "pkGtid", displayName: "Grievance Type Id" },
  { value: "BOARD", lowercaseValue: "boardName", displayName: "Board" },
  { value: "DEPARTMENT", lowercaseValue: "departmentName", displayName: "Department" },
  { value: "GRIEVANCE TYPE", lowercaseValue: "gtGrievanceType", displayName: "Grievance Type" },
  { value: "LEVEL", lowercaseValue: "gtLevels", displayName: "Level" },
  { value: "Escalation days", lowercaseValue: "gtEscalationDuration", displayName: "Escalation days" },
];

export class GrievanceList {
  pkGtid: any;
  boardName: any;
  departmentName: any;
  gtGrievanceType: any;
  gtLevels: string;
  gtEscalationDuration: any;
}
@Component({
  selector: 'app-list-grievance-type',
  templateUrl: './list-grievance-type.component.html',
  styleUrls: ['./list-grievance-type.component.scss'],
})
export class ListGrievanceTypeComponent implements OnInit {
  displayedCols = COLS;
  allCols = COLS;
  loading = true;
  noGtypeData=ProjectConstants.gtypeNotAvailable
  id: any;
  myid: any;
  progressSpinnerDialog: any = null;
  displayedColumns: any[];
  grievanceTypeList: GrievanceList[] = [];
  customGrievanceList: any = [];
  dataSource = new MatTableDataSource(this.grievanceTypeList);
  grievanceType: any;
  filterForm: FormGroup = new FormGroup({});
  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  constructor(public grievanceTypeService: GrievanceTypeService,
    public datepipe: DatePipe,
    public router: Router,
    public dialog: MatDialog,
    private commonFunction: CommonFunction) { }

  ngOnInit() {
    this.displayedCols = [
      { value: "GRIEVANCE TYPE ID", lowercaseValue: "pkGtid", displayName: "Grievance Type Id" },
      { value: "BOARD", lowercaseValue: "boardName", displayName: "Board" },
      { value: "DEPARTMENT", lowercaseValue: "departmentName", displayName: "Department" },
      { value: "GRIEVANCE TYPE", lowercaseValue: "gtGrievanceType", displayName: "Grievance Type" },
      { value: "LEVEL", lowercaseValue: "gtLevels", displayName: "Level" },
      { value: "Escalation days", lowercaseValue: "gtEscalationDuration", displayName: "Escalation days" },
    ];
    this.displayedColumns = this.displayedCols.map((col) => col.value);
    this.dataSource.paginator = this.paginator;
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [Validators.required])
    });
    this.loadList();
  }

  async loadList() {
    this.displayProgressSpinner();
    const response: any = await this.grievanceTypeService.loadGrievanceType()
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.length != 0) {
        if (response[0].status == ProjectConstants.responseStatusSuccess) {
          for (var i = 0; i < response.length; i++) {
            this.loading = false
            const customObj = new GrievanceList();
            customObj.pkGtid = response[i].pkGtid
            customObj.boardName = response[i].boardName
            customObj.gtGrievanceType = response[i].gtGrievanceType
            customObj.gtLevels = response[i].gtLevels
            customObj.gtEscalationDuration = response[i].gtEscalationDuration
            customObj.departmentName = response[i].departmentName
            this.grievanceTypeList.push(customObj)
          }
          this.dataSource.data = this.grievanceTypeList;
        } else if (response[0].status == ProjectConstants.responseStatusFailure) {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        }
      } else {
        this.grievanceTypeList = []
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
      this.grievanceTypeList = []
      this.dataSource.data = this.grievanceTypeList;
    }
    this.displayedColumns = this.displayedCols.map((col) => col.value);
  }


  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }


  updateGrievanceType(gtypeId) {
    this.router.navigate(['secure/update-grievance-type/' + gtypeId])
  }

  addEscalation(gtypeId) {
    this.router.navigate(['secure/list-escalation-duration/' + gtypeId])
  }


  async deleteGrievanceType(gtypeId) {
    const data = {
      'gtId': gtypeId
    }
    const dialogRef = this.dialog.open(CloseGrievanceDialogComponent, {
      width: 'fit-content',
      data: { id: 'delete', content: "Grievance Type" },
    });
    dialogRef.afterClosed().subscribe(async result => {
      var returnval = result;
      if (returnval == ProjectConstants.noMsg) {
        this.grievanceType = false
      } else {
        this.grievanceType = true
        this.displayProgressSpinner();
        const response: any = await this.grievanceTypeService.deleteGrievanceType(data)
        this.progressSpinnerDialog.close()
        if (response != null && !response.error) {
          if (response.status === ProjectConstants.responseStatusSuccess) {
            await this.commonFunction.successToast(ProjectConstants.gtypeDeleteSuccessMsg,false,"")
            window.location.reload()
            this.router.navigate(['secure/grievance-type-list'])
          }
          else if (response.status === ProjectConstants.responseStatusFailure) {
            if (response.code == ProjectConstants.gtypeIsinuseStatusCode) {    
              await this.commonFunction.errorToast(ProjectConstants.gtypeIsinuseStatusMsg, false, "")
            } else {
              await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
            }
          }
        } else {
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg, false, "")
        }

      }
    });

  }
  escalationDurationList(gtypeId) {
    this.router.navigate(['secure/list-escalation-duration/' + gtypeId])
  }


  applyFilter(search: any) {
    const filterValue = search;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  resetFilter() {
    this.filterForm.controls['filterText'].setValue(null);
    const filterValue = ''
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}




